// useClearCreateContexts.ts
// import other create-related contexts as needed

import { useConflictCheck } from '../context/ConflictCheckContext';
import { useManageMatterRequestContext } from '../context/ManageMatterRequest';
import { useMatterRequest } from '../context/MatterRequestContext';
import { useTask } from '../context/TaskContext';
import { useTimer } from '../context/TimerContext';
import { useTransaction } from '../context/TransactionContext';
import { useWorkTime } from '../context/WorkTimeContext';

export const useClearCreateContexts = () => {
  const { updateWorkTime } = useWorkTime();
  const { updateTransaction } = useTransaction();
  const { updateTask } = useTask();
  const { updateTimer } = useTimer();
  const { updateMatterRequestParams } = useMatterRequest();
  const { updateConflictCheckParams } = useConflictCheck();
  const { updateManageMatterRequest } = useManageMatterRequestContext();

  const clearAll = () => {
    updateWorkTime(null);
    updateTransaction(null);
    updateTask(null);
    updateTimer(null);
    updateMatterRequestParams(null);
    updateConflictCheckParams(null);
    updateManageMatterRequest(null);
  };

  return clearAll;
};
